import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
  name: 'highlight'
})
export class HighlightPipe implements PipeTransform {

  transform(value: string, ...args: unknown[]): unknown {
    const text = args.length > 0 ? args[0]?.toString() : undefined;

    if (text?.length) {
      text.split('|')
        .map(word => new RegExp(word, 'gi'))
        .forEach(regex => value = value.replace(regex, (match) => `<mark>${match}</mark>`));
    }

    return value;
  }

}
